import merge from 'lodash/merge';
import xssOriginal, {
  cssFilter,
  escapeHtml,
  safeAttrValue,
  whiteList,
  type IFilterXSSOptions,
  type IWhiteList,
} from 'xss';

/** Default whitelist plus tags from trusted Markdown (e.g. task list checkboxes). */
const SANITIZE_HTML_WHITE_LIST: IWhiteList = {
  ...whiteList,
  input: ['type', 'class', 'checked', 'disabled'],
};

function xss(dirty: string, customOptions?: IFilterXSSOptions): string {
  const defaultOptions: IFilterXSSOptions = merge<
    IFilterXSSOptions,
    IFilterXSSOptions,
    IFilterXSSOptions
  >(
    {},
    { whiteList: SANITIZE_HTML_WHITE_LIST },
    {
      onTagAttr(tag, name, value) {
        if (
          tag === 'input' &&
          name === 'type' &&
          String(value).trim().toLowerCase() !== 'checkbox'
        ) {
          return '';
        }
        const isClass = name === 'class';
        const isStyle = name === 'style';
        const isData = name?.startsWith('data');
        if (isClass || isStyle || isData) {
          const safeValue = safeAttrValue(tag, name, value, cssFilter);
          return `${name}="${safeValue}"`;
        }
        return undefined;
      },
    },
  );
  const options = customOptions || defaultOptions;
  return xssOriginal(dirty, options);
}

function xssStrip(dirty: string): string {
  return xssOriginal(dirty, {
    whiteList: {}, // empty, means filter out all tags
    stripIgnoreTag: true, // filter out all HTML not in the whilelist
    stripIgnoreTagBody: ['script'], // the script tag is a special case, we need to filter out its content
  });
}

function xssEscapeHtml(html?: string | null): string {
  if (!html) {
    return '';
  }
  return escapeHtml(html);
}

export { xss, xssEscapeHtml, xssStrip };
